<template>
  <v-app-bar :color="bgcolor" elevation="0">
    <v-row justify="space-between" align="center">
      <v-col md="5" lg="4" xl="2" cols="12" align="left" class="pl-0 pr-0">
        <v-btn
          small
          color="transparent"
          elevation="0"
          @click="
            goTo('Main');
            bgcolor = 'transparent';
            showSwitcher = true;
          "
          >Birdwatcher</v-btn
        >
        <v-btn
          small
          color="transparent"
          elevation="0"
          @click="
            goTo('About');
            bgcolor = 'white';
            showSwitcher = false;
          "
          >About</v-btn
        >
        <v-btn
          small
          color="transparent"
          elevation="0"
          @click="
            goTo('Encyclopedia');
            bgcolor = 'white';
            showSwitcher = false;
          "
          >Encyclopedia</v-btn
        >
      </v-col>
      <v-col> </v-col>
      <v-col cols="2" md="2" lg="2" xl="2"
        ><v-btn
          small
          color="transparent"
          elevation="0"
          @click="
            goTo('Download');
            bgcolor = 'white';
            showSwitcher = false;
          "
          >Download Music</v-btn
        ></v-col
      >
      <v-col cols="1" md="1" lg="1" xl="1">
        <v-btn icon class="volume-btn" @click="$emit('toggle-music')"
          ><v-icon v-if="musicOn">mdi-volume-high</v-icon
          ><v-icon v-else>mdi-volume-off</v-icon></v-btn
        ></v-col
      >
      <v-col v-if="showSwitcher" cols="1"
        ><Switcher :isDay="isDay" :freeze="freezeSwitch" @switch="onSwitch"
      /></v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import router from "../router/index";
import Switcher from "../components/Switcher.vue";

export default {
  props: {
    isDay: Boolean,
    musicOn: Boolean,
  },
  components: { Switcher },
  data() {
    return {
      bgcolor: "transparent",
      showSwitcher: true,
      freezeSwitch: false,
    };
  },
  methods: {
    goTo(route) {
      this.$route.name !== route ? router.push({ name: route }) : null;
    },
    onSwitch() {
      this.$emit("change-music-theme");
      this.freezeSwitch = true;
      setTimeout(() => {
        this.freezeSwitch = false;
      }, 3000);
    },
  },
};
</script>
<style scoped>
.v-app-bar {
  z-index: 9900;
  position: fixed;
  top: 0%;
  left: 0;
}
.volume-btn img {
  width: 24px;
}

.switcher-btn {
  width: 50%s;
}
.v-btn {
  font-family: "MabryBold";
}
</style>